module.exports = __webpack_public_path__ + "img/platform-load.48bc712f.png";